module.exports = __webpack_public_path__ + "static/img/star.6af81644.png";